import { BaseContainerModel } from "../base-container.model";
import { bl_wms_putaway_list_RowInterface, bl_wms_putaway_list_RowClass, bl_wms_putaway_processing_queue_RowInterface, bl_wms_putaway_processing_queue_RowClass } from "../../dbschema/index";

export class WmsPutawayContainerModel extends BaseContainerModel {
  bl_wms_putaway_list: bl_wms_putaway_list_RowInterface = new bl_wms_putaway_list_RowClass();
  bl_wms_putaway_processing_queue: bl_wms_putaway_processing_queue_RowInterface = new bl_wms_putaway_processing_queue_RowClass();
}
